<style lang="sass" scoped>
@use "./style/index" as *

.questions_box
  position: relative
  display: flex
  flex-direction: column
  height: calc(var(--vh, 1vh) * 100 - 46px)

  .only_one_title
    padding-bottom: 0

.title
  padding-bottom: 16px
  text-overflow: ellipsis
  white-space: nowrap
  border-radius: 18PX 18PX 0 0
  line-height: 35PX
  font-size: 16px
  text-align: center
  overflow: hidden
  background: #fff
  z-index: 2
  background: #f3f3f3
  border-bottom: 1px solid rgba(50, 56, 62, 0.1)

  .label_text
    display: flex
    justify-content: center
    padding: 4px 0px
    font-size: 12px
    letter-spacing: 0.5px

  .progress_box
    padding: 0 20px

  .label_box
    position: absolute
    top: 51px
    left: 0
    right: 0
    padding: 0px 20px
    background: #f3f3f3
    border-bottom: 1px solid #e3e3e4

    .prompt_title
      margin: 20px 0 16px 0
      font-size: 22px
      font-weight: 900
      line-height: 26px

    .prompt_text
      margin-bottom: 20px
      font-size: 14px
      font-weight: 400
      line-height: 17px

  .only_label
    top: 0

.component_box
  position: relative
  flex: 1
  overflow: auto

.footer
  position: absolute
  top: 0
  display: flex
  justify-content: space-around
  align-items: center
  width: 100vw
  height: 94px
  border-top: 1px solid #e8e8e9
  background: #fff
  font-weight: bold

  .footer_button
    width: calc(100vw - 30PX)

  .footer_another
    width: 45%
    border-radius: 4px !important
    overflow: hidden

    ::v-deep
      .van-button__text
        white-space: pre-wrap

.index
  position: absolute
  top: 0
  width: 100%

.button
  position: absolute
  display: block
  width: 16px
  top: 0
  right: 50%
  margin-right: -8px
  font-weight: Bold

.button_box
  position: relative
  height: 94px

.text_span
  position: relative
  display: block
  width: 20px
  height: 12px

.text_right
  margin-left: 6px
  font-weight: Bold

.labelBox_margin
  margin-top: var(--labelBoxHeight)

.wrapper
  position: relative
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  padding: 10px
  height: 500px
  width: 300px
  overflow: auto

.block
  display: flex
  flex-direction: column
  flex: 1
  width: 100%
  margin-top: 26px
  background-color: #fff
  overflow: auto
  border-radius: 10px

  ::v-deep
    *
      white-space: pre-wrap !important

.close_icon
  position: absolute
  top: 8px
  right: 8px
  color: var(--menu-primary-background-colour) !important
  cursor: pointer

.theme_color
  color: var(--menu-primary-background-colour) !important

.review_btn_text
  vertical-align: middle

.review_btn_g
  width: 22px
  height: 22px
  margin-left: 6px
  vertical-align: middle

::v-deep
.van-popup
  border-radius: 18px !important

#progress
  height: 10px
  border-radius: 15px
  overflow: hidden
  background: rgba(50, 56, 62, 0.15)

#progress span
  display: flex
  height: 10px
  background: var(--menu-primary-background-colour)
  color: #fff
  transition: width .5s
  border-radius: 15px
</style>

<template lang="pug">
.questions_box
  .title(:class="{ 'only_one_title': componentNameArrLength === 1 }")
    .label_text(v-if="componentNameArrLength > 1") {{ t('question', 'QUESTION') }}
      span.text_span
        transition(name="button")
          span.button(v-if='isShow' key='1') {{ indexCombo + 1 }}
          span.button(v-else) {{ indexCombo + 1 }}
      span {{ t('of', 'OF') }}
      span.text_right {{ componentNameArrLength }}

    .progress_box(v-if="componentNameArrLength > 1")
      #progress
        span(:style="{ width: progressTotal + '%' }")

    transition(name="label")
      .label_box(v-if="!indexCombo" :class="{ 'only_label': componentNameArrLength === 1 }" ref="labelBox")
        .prompt_title {{ isReviewHero ? reviewHeaderText : t('thank_you_for_order', 'Thank you for your order!') }}
        .prompt_text {{ t('please_answer_questions', 'Please take a moment to answer the following questions.') }}

  .component_box
    transition
      component.index(
        v-if="showComponentBox"
        key='1'
        ref="component"
        :class="{ 'labelBox_margin': !indexCombo }"
        :style="{ '--labelBoxHeight': labelBoxHeight }"
        :is="componentsName + '-components'"
        :index="indexCombo"
        :data="questionData"
        :imgSrc="imgSrc"
        :marketingConsentMessage="marketingConsentMessage"
        @event="event"
        @open="openCampaign"
      )
      component.index(
        v-else
        ref="component"
        :class="{ 'labelBox_margin': !indexCombo }"
        :style="{ '--labelBoxHeight': labelBoxHeight }"
        :is="componentsName + '-components'"
        :index="indexCombo"
        :data="questionData"
        :imgSrc="imgSrc"
        :marketingConsentMessage="marketingConsentMessage"
        @event="event"
        @open="openCampaign"
      )

  .button_box
    transition-group(name="button")
      .footer(
        v-if="isCampaigns !== 1 || (questionData && questionData.type !== 'campaign') || indexCombo !== 0"
        :key='1'
        ref="footer"
      )
        van-button.footer_button(
          size="large"
          type="primary"
          :disabled="disabled"
          @click="switchComponent(true)"
        ) {{ buttonText }}

      .footer(v-if="questionData && (questionData.type === 'campaign')" :key="2")
        van-button.footer_another.theme_color(
          size="large"
          @click="switchComponent(false)"
        ) {{ rejectButtonText }}

        van-button.footer_another(
          size="large"
          type="primary"
          @click="focusDialog('campaign')"
        )
          template(v-if="isReviewHero")
            span.review_btn_text {{ reviewBtnText }}
            img.review_btn_g(src="@/assets/icon/google-g.svg" v-if="questionData.settings.campaign.icon !== 'review'")
          template(v-else) {{ acceptButtonText }}

      .footer(v-if="isCampaigns === 1 && !indexCombo && !questionData" :key="3")
        van-button.footer_another.theme_color(
          size="large"
          @click="refuseMarketing"
        ) {{ t('no_thanks', 'NO THANKS') }}

        van-button.footer_another(
          size="large"
          type="primary"
          @click="signUp"
        ) {{ t('sign_up', 'SIGN UP') }}

  van-popup(v-model='showCampaign')
    .wrapper
      icon.close_icon(size='26' @click='showCampaign = false') close

      .block(v-if="questionData && questionData.settings")
        div(v-html='questionData.settings.terms')
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import faceComponents from './components/faceComponents'
import numberComponents from './components/numberComponents'
import starComponents from './components/starComponents'
import textComponents from './components/textComponents'
import campaignComponents from './components/campaignComponents'
import marketingComponents from './components/marketingComponents'
import { mapState } from 'vuex'
import { campaignFailTab, campaignLastSurvey, campaignMainTab, campaignTab } from 'utils/message'
import { answerCampaign } from 'api/product'
import { getLocalizedCampaignField, t } from '@/utils/language'
import dayjs from 'dayjs'

@Component({
  props: {
    showSurveys: Boolean, // 是否展示弹窗
    data: Array, // 反馈列表数据
    isCampaigns: Number, // 0: 不显示  1: 营销+反馈  2: 营销  3: 反馈
    imgSrc: String, // 邮件营销，展示图片路径
    marketingConsentMessage: String, // 邮件营销，展示文案
    orderId: String
  },

  components: {
    faceComponents,
    numberComponents,
    starComponents,
    textComponents,
    campaignComponents,
    marketingComponents
  },

  computed: {
    ...mapState({
      venueId: state => state.venueId,
      userInfo: state => state.contactDetails.user,
      venueName: state => state.checkinInfo.name,
    }),

    /**
     * @return {String} 按钮文案
     */
    buttonText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      let text = t('next', 'NEXT')
      if (this.componentNameArrLength === 1) text = t('submit', 'SUBMIT')
      else if (this.componentNameArrLength === (this.indexCombo + 1)) text = t('finish', 'FINISH')
      return text
    },

    /**
     * @return {String} 拒绝按钮文案
     */
    rejectButtonText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      const text = getLocalizedCampaignField(this.questionData, 'rejectText')
      return text || t('no_thanks', 'NO THANKS')
    },

    /**
     * @return {String} 接受按钮文案
     */
    acceptButtonText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      const text = getLocalizedCampaignField(this.questionData, 'acceptText')
      return text || t('next', 'NEXT')
    },

    // Google Review 英雄区版式(thirdPartyReview + layout=googleReviewHeroV1)才用新 header / 按钮
    isReviewHero() {
      const c = this.questionData?.settings?.campaign
      return c?.type === 'thirdPartyReview' && c?.layout === 'googleReviewHeroV1'
    },

    // 第三方评价顶部 header 文案;可由 settings.campaign.headerText 覆盖,缺省 "Thank you for your support!"
    reviewHeaderText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return this.questionData?.settings?.campaign?.headerText || t('thank_you_for_support', 'Thank you for your support!')
    },

    // 第三方评价按钮文案
    reviewBtnText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.questionData, 'acceptText') || t('review_us_on', 'Review us on')
    },

    // 判断出进度条的每次增加应该增加几
    progressNum() {
      return Math.ceil(100 / this.componentNameArr.length)
    },

    // 判断下一步按钮，是否禁用。如果页面类型是 survey 并且没有选中任何题型的时候禁用。
    disabled() {
      const type = this.questionData?.type ?? 'survey'
      const index = this.isSelected
      return (index === null && type === 'survey')
    },

    labelBoxHeight() {
      return this.componentNameArrLength === 1 ? this.boxHeight + 'px' : this.boxHeight - 16 + 'px'
    }
  },

  watch: {
    showSurveys: {
      handler(newName) {
        // 特别注意，不能用箭头函数，箭头函数，this 指向全局
        if (newName) {
          this._initData()
        }
      },
      immediate: true // 刷新加载，立马触发一次 handler
    },

    showComponentBox: {
      handler(newName) {
        this.$nextTick(_ => {
          // 除邮件营销以外，查看反馈时，提交接口
          if (this.componentsName !== 'marketing') this._answerCampaign('view', false)
          // 切换组件时，清空组件数据
          if (this.$refs.component._initializationData) this.$refs.component._initializationData()
        })
      },
      immediate: true
    }
  }
})

class FeedbackStatistics extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  indexCombo = 0 // 当前页在题列表的下标
  progressTotal = 0 // 头部进度条的百分比
  componentsName = '' // 当前页的题型名称
  questionData = null // 当前页的相关数据
  componentNameArr = [] // 题型名称列表
  componentNameArrLength = 0 // 题型名称列表的长度
  isShow = true // 控制 QUESTION 数字 动画
  isSelected = null // 判断当前页面题型是否被选中的变量
  boxHeight = 0 // labelBox 高度
  showCampaign = false // 活动页面是否弹出
  showComponentBox = true // 控制题型内容动画
  hasCampaign = false // 是否有关联广告
  isRelationCampaign = false // 是否是关联广告
  dataList = false

  mounted() {
    // 页面第一次加载赋值下 labelBox 高度
    this.boxHeight = this.$refs.labelBox?.offsetHeight ?? 0
    this._setVh()
  }

  /**
   * 点击下一页
   * @param optin {Boolean} 点击 '确认' 还是 '取消' 按钮
   */
  async switchComponent(optin = true) {
    // 是否是邮件营销弹窗
    const isMarketing = this.componentsName === 'marketing'
    const type = this.questionData?.type ?? 'survey'
    // 是否是第三方评价(Google Review)卡
    const isThirdPartyReview = this.questionData?.settings?.campaign?.type === 'thirdPartyReview' && this.questionData?.settings?.campaign?.externalUrl
    // 是否通过 API 提交
    let isSuccess = true
    if (this.isSelected === null && type === 'survey' && !isMarketing) return
    // 第三方评价:accept 时打开评价链接。必须在 await 之前同步调用 window.open 以保留用户手势
    // (iOS Safari/WebKit 对手势要求严格,await 之后再 open 会被弹窗拦截);先打开,再提交统计。
    const reviewUrl = this.questionData?.settings?.campaign?.externalUrl
    let reviewWin = null
    if (isThirdPartyReview && optin === true && reviewUrl) {
      reviewWin = window.open(reviewUrl, '_blank')
    }
    if (!isMarketing) {
      this.$store.commit('showLoading')
      isSuccess = await this._answerCampaign('answer', optin)
      this.$store.commit('closeLoading')
    }
    // 内嵌浏览器(微信/Teams 等 App 内置 WebView,没有多标签)里 window.open 会返回 null、
    // 不弹新标签 → 用当前页跳转兜底,保证"点了有反应"(代价:用户需手动点返回键回到订单页)。
    if (isThirdPartyReview && optin === true && reviewUrl && !reviewWin) {
      window.location.href = reviewUrl
    }
    // 没通过 API 提交，出现弹窗，并终止运行
    if (!isSuccess) this.focusDialog('fail')
    if (!isSuccess) return
    // 有选项有关联广告的情况
    if (this.hasCampaign && this.questionData?.type !== 'campaign') {
      this.componentsName = this.hasCampaign.type
      this.questionData = this.hasCampaign
      this.isSelected = null // 是否选择题型变量重置
      this.showComponentBox = !this.showComponentBox
      this.hasCampaign = false
      this.isRelationCampaign = true
      return
    }
    this.isRelationCampaign = false
    if (this.indexCombo < this.componentNameArr.length - 1) {
      // 判断段是否大于了 indexCombo componentNameArr 数组的长度
      this.indexCombo++ // 点击一次，加一次
      this.componentsName = this.componentNameArr[this.indexCombo] // 获取组件前缀
      const index = this.indexCombo + 1 // 增加进度条的进度
      const dataIndex =
      this.isCampaigns === 1 ? this.indexCombo - 1 : this.indexCombo // isCampaigns 等于 1 的时候，indexCombo 需要减 1
      this.progressTotal = Math.ceil(this.progressNum * index) // 获取进度条的百分比
      this.questionData = this.dataList[dataIndex] // 获取对应组件的数据
      this.isShow = !this.isShow // 数字动画切换
      this.isSelected = null // 是否选择题型变量重置
      this.hasCampaign = false
      this.showComponentBox = !this.showComponentBox
    } else if (this.indexCombo === this.componentNameArr.length - 1) {
      if (this.questionData?.type === 'survey') {
        // survey 项顶层无 thankyouText,回退读 settings.thankyouText(低分自定义感谢文案)
        this.focusDialog('lastSurvey', getLocalizedCampaignField(this.questionData, 'thankyouText') || this.questionData?.settings?.thankyouText)
      } else {
        this.$emit('closeDialog')
      }
    } else {
      this.indexCombo = this.componentNameArr.length - 1 || 1 // 如果超出了 componentNameArr 数组长度，则一直赋值 componentNameArr 数组长度
    }
  }

  /**
   * 选中反馈选项
   * @param value {String, Number} 选项值
   * @param hasCampaign {Boolean} 是否存在关联广告
   */
  event(value, hasCampaign = false) {
    this.hasCampaign = hasCampaign
    this.isSelected = value
  }

  openCampaign(open) {
    this.showCampaign = open
  }

  // 拒绝邮件营销
  refuseMarketing() {
    const nowTime = dayjs.tz().format('YYYY-MM-DD')
    const { venueId } = this
    this.$store.commit('signUpDialogOnceTime/SET_SIGN_UP_POPUP_ONCE_TIME', { nowTime, venueId })
    this.switchComponent()
  }

  // 出现 campaign 组件，点击关注的时候就会出现一个弹窗
  focusDialog(val, thankyouText = '', thankyouTitle = '') {
    const self = this
    // 第三方评价卡 / 无感谢文案:不弹对话框,直接走 switchComponent(其会打开评价链接)
    if (thankyouText === false || this.questionData?.settings?.campaign?.type === 'thirdPartyReview') {
      this.switchComponent()
      return
    }
    const messageObj = {
      campaign: campaignTab(this.userInfo?.email ?? '', thankyouText, thankyouTitle),
      main: campaignMainTab(),
      fail: campaignFailTab(),
      lastSurvey: campaignLastSurvey(thankyouText)
    }

    this.$createTabMessageDialog({
      $props: messageObj[val],
      $events: {
        click() {
          self.showManageTabDialog = true
          // 是接口报错弹窗时，终止运行
          if (val === 'fail') return
          if (val === 'lastSurvey') {
            self.$emit('closeDialog')
            return
          }
          self.switchComponent()
        },
      },
    }).show()
  }

  // 加入邮件营销
  signUp() {
    this.$emit('signUp')
    this.focusDialog('main')
  }

  _initData() {
    this.componentNameArr = this._setData()
    this.progressTotal = this.progressNum
    this.componentsName = this.componentNameArr[0]
    if (this.isCampaigns !== 1) this.questionData = this.dataList !== false ? this.dataList[0] : this.data[0]
  }

  _setData() {
    if (this.dataList === false) {
      this.dataList = this.data
    }
    if (!this.dataList) return []

    // Expand surveyList type: replace it with its optinCampaigns (like inline expansion)
    // 展开 surveyList 类型：用其 optinCampaigns 替换（类似内联展开）
    const expandedList = []
    this.dataList.forEach(item => {
      if (item.type === 'surveyList' && item.settings?.campaign?.optinCampaigns?.length) {
        expandedList.push(...item.settings.campaign.optinCampaigns)
      } else {
        expandedList.push(item)
      }
    })
    this.dataList = expandedList

    const nameArr = this.dataList.map(item => {
      return item.type !== 'campaign' ? item.settings?.survey?.iconType : item.type
    })

    if (this.isCampaigns === 1) nameArr.unshift('marketing')
    this.componentNameArrLength = nameArr.length
    return nameArr
  }

  _closeAnswerCampaign() {
    this._answerCampaign('close', false)
  }

  /**
   * 提交反馈结果
   * @param action {String} 提交类型
   * @param optin {Boolean} 点击 '确认' 还是 '取消' 按钮
   * @return {Boolean} 是否提交通过
   */
  async _answerCampaign(action, optin) {
    // 管理后台的预览模式时，不执行下面代码
    if (this.$route.query.isIframeCondition) return
    const userId = localStorage.getItem('userId')
    const {
      email,
      name,
      phone
    } = this.userInfo
    const id = this.componentsName === 'marketing' ? 'marketing' : this.questionData.id
    const type = this.questionData?.type ?? ''
    let step = this.componentNameArr.find(item => item === 'marketing') ? this.indexCombo : this.indexCombo + 1
    if (this.isRelationCampaign) step += 0.1 // 若现在是关联广告，需要加 0.1
    const data = {
      userId,
      campaignAnswer: {
        id,
        email,
        name,
        phone,
        userId,
        venueId: this.venueId,
        venueName: this.venueName,
        campaign: {
          id,
          name: this.questionData?.name ?? '',
          type,
          questionType: this.questionData?.settings?.survey?.questionType ?? '',
          surveyType: this.questionData?.settings?.survey?.type ?? '',
          iconType: this.questionData?.settings?.survey?.iconType ?? '',
        },
        answer: this.isSelected,
        optin,
        action,
        step,
        timestamp: dayjs.tz().format('YYYY-MM-DD HH:mm:ss'),
        orderId: this.orderId
      }
    }
    let isSuccess = true
    await answerCampaign(data).catch(_ => {
      isSuccess = false
      this.$store.commit('closeLoading')
    })
    return isSuccess
  }

  // 设置 sass 变量：vh
  _setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
  }
}
export default FeedbackStatistics
</script>
